module.exports = __webpack_public_path__ + "static/img/quanliucheng_0111.a77d81a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/quanliucheng_0111.png
// module id = 2pTF
// module chunks = 1